var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_4285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C11.5859 3 13.0209 3.52992 14.1963 4.41406L12.7119 5.89844C11.9411 5.37821 11.0126 5.06836 10 5.06836C7.26931 5.06836 5.06836 7.26931 5.06836 10C5.06836 12.7307 7.26931 14.9316 10 14.9316C12.2551 14.9316 14.0789 13.7635 14.5127 11.6338L14.6348 11.0342H10.5V9.13672H16.5781C16.6283 9.43088 16.6592 9.72562 16.6592 10C16.6592 14.4813 13.4894 17 10 17C6.11705 17 3 13.8829 3 10C3 6.11705 6.11705 3 10 3Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_4285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81824 14.4318V5.56812L7.61369 9.99993L1.81824 14.4318Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_392_4285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 8.63636H10V11.5341H14.0227C13.6477 13.375 12.0795 14.4318 10 14.4318C7.54546 14.4318 5.56818 12.4545 5.56818 10C5.56818 7.54545 7.54546 5.56818 10 5.56818C11.0568 5.56818 12.0114 5.94318 12.7614 6.55682L14.9432 4.375C13.6136 3.21591 11.9091 2.5 10 2.5C5.84091 2.5 2.5 5.84091 2.5 10C2.5 14.1591 5.84091 17.5 10 17.5C13.75 17.5 17.1591 14.7727 17.1591 10C17.1591 9.55682 17.0909 9.07955 16.9886 8.63636Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_392_4285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81824 5.56812L7.61369 9.99993L10.0001 7.92039L18.1819 6.59084V1.81812H1.81824V5.56812Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_392_4285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 8.63636H10V11.5341H14.0227C13.6477 13.375 12.0795 14.4318 10 14.4318C7.54546 14.4318 5.56818 12.4545 5.56818 10C5.56818 7.54545 7.54546 5.56818 10 5.56818C11.0568 5.56818 12.0114 5.94318 12.7614 6.55682L14.9432 4.375C13.6136 3.21591 11.9091 2.5 10 2.5C5.84091 2.5 2.5 5.84091 2.5 10C2.5 14.1591 5.84091 17.5 10 17.5C13.75 17.5 17.1591 14.7727 17.1591 10C17.1591 9.55682 17.0909 9.07955 16.9886 8.63636Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_392_4285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81824 14.4318L12.0455 6.59084L14.7387 6.93175L18.1819 1.81812V18.1818H1.81824V14.4318Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_392_4285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 8.63636H10V11.5341H14.0227C13.6477 13.375 12.0795 14.4318 10 14.4318C7.54546 14.4318 5.56818 12.4545 5.56818 10C5.56818 7.54545 7.54546 5.56818 10 5.56818C11.0568 5.56818 12.0114 5.94318 12.7614 6.55682L14.9432 4.375C13.6136 3.21591 11.9091 2.5 10 2.5C5.84091 2.5 2.5 5.84091 2.5 10C2.5 14.1591 5.84091 17.5 10 17.5C13.75 17.5 17.1591 14.7727 17.1591 10C17.1591 9.55682 17.0909 9.07955 16.9886 8.63636Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_392_4285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 18.1818L7.61364 9.99993L6.25 8.97721L18.1818 5.56812V18.1818Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c43054d282e64ab95ee07690c8f0f465.svg";
export { ForwardRef as ReactComponent };